import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';

import { routing } from './cms.routing';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { CmsComponent } from './cms.component';
import { CustomersComponent } from './customers/customers.component';
import { AddressInfoComponent } from './customers/address-info/address-info.component';
import { SuspendedUsersComponent } from './suspended-users/suspended-users.component';
import { CmsService } from './cms.service';
import { BonusCodeComponent } from './bonus-code/bonus-code.component';
import { ExportExcelComponent } from './export-excel/export-excel.component';
import { ExcelExportService } from './excel.export.service';
import {NumNotRoundPipe} from 'src/app/shared/pipes/common.pipe';
import { TooltipModule } from 'primeng/tooltip';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { TradingHistoryComponent } from './customers/training-history/training-history.component';
import { MamPammFollowerComponent } from './mam-pamm-follower/mam-pamm-follower.component';
import { TopListComponent } from './top-list/top-list.component';
import { MamDetailComponent } from './mam-pamm-follower/mam-detail/mam-detail.component';
import { MamListComponent } from './mam-pamm-follower/mam-list/mam-list.component';
import { TraderComponent } from './trader/trader.component';
import { TraderBalanceComponent } from './trader/trader-balance/trader-balance.component';
import { TraderBonusDetailComponent } from './trader/trader-bonus-detail/trader-bonus-detail.component';
import { TraderBonusContributionComponent } from './trader/trader-bonus-contribution/trader-bonus-contribution.component';
import { TraderListComponent } from './trader/trader-list/trader-list.component';
import { SidebarModule } from 'primeng/sidebar';
import { IBService } from './ib/ib.service';
import { TopListIBComponent } from './ib/top-list/top-list.component';
import { IbNetworkComponent } from './ib/ib-network/ib-network.component';
import { IbDetailComponent } from './ib/ib-detail/ib-detail.component';
import { ExportAutoComponent } from './ib/export-auto/export-auto.component';
import { DiscretionaryComponent } from './ib/discretionary/discretionary.component';
import { CampaignListComponent } from './ib/campaign-list/campaign-list.component';
import { IBComponent } from './ib/ib.component';
import { CmsDetailComponent } from './cms-detail/cms-detail.component';

@NgModule({
  declarations: [
    CmsComponent,
    CustomersComponent,
    SuspendedUsersComponent,
    AddressInfoComponent,
    BonusCodeComponent,
    ExportExcelComponent,
    TradingHistoryComponent,
    MamPammFollowerComponent,
    TopListComponent,
    MamDetailComponent,
    MamListComponent,
    TraderComponent,
    TraderBalanceComponent,
    TraderBonusDetailComponent,
    TraderBonusContributionComponent,
    TraderListComponent,
    IBComponent,
    TopListIBComponent,
    IbNetworkComponent,
    IbDetailComponent,
    ExportAutoComponent,
    DiscretionaryComponent,
    CampaignListComponent,
    CmsDetailComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    SharedModule,
    CalendarModule,
    DropdownModule,
    routing,
    ReactiveFormsModule,
    TooltipModule,
    DynamicDialogModule,
    DialogModule,
    SidebarModule
  ],
  providers: [CmsService,IBService, DecimalPipe, ExcelExportService, NumNotRoundPipe, DatePipe, DialogService],
})
export class CmsModule {}
